/*
 * Global JavaScript error attribution for Microsoft Clarity.
 *
 * This is intentionally an unminified theme asset so first-party stack traces
 * retain a stable asset URL and line number in browser developer tools.
 */
(function (window) {
  'use strict';

  if (window.__oneisallErrorMonitorInstalled) return;
  window.__oneisallErrorMonitorInstalled = true;

  function browserName() {
    var ua = navigator.userAgent || '';
    if (/Instagram/i.test(ua)) return 'instagram-in-app';
    if (/FBAN|FBAV|Facebook/i.test(ua)) return 'facebook-in-app';
    if (/CriOS/i.test(ua)) return 'ios-chrome';
    if (/Chrome|CriOS/i.test(ua)) return 'chrome';
    if (/Safari/i.test(ua)) return 'safari';
    return 'other';
  }

  function sourceCategory(source) {
    if (!source) return 'unknown-cross-origin';
    if (/^(chrome|safari|moz)-extension:/i.test(source)) return 'autofill-or-extension';

    var hostname;
    try {
      hostname = new URL(source, window.location.href).hostname;
    } catch (ignore) {
      return 'unknown';
    }

    if (hostname === window.location.hostname || /(^|\.)(myshopify\.com|shopify\.com|shopifycdn\.com)$/i.test(hostname)) return 'first-party';
    if (/(^|\.)(connect\.facebook\.net|facebook\.com|googletagmanager\.com|google-analytics\.com|preciso\.net)$/i.test(hostname)) return 'third-party-marketing';
    if (/(^|\.)(pagefly\.io|bbqbi\.com|gstatic\.com|archetypethemes\.co)$/i.test(hostname)) return 'third-party-app';
    return 'third-party';
  }

  function normaliseSource(source) {
    if (!source) return 'unavailable';
    try {
      var url = new URL(source, window.location.href);
      return (url.origin + url.pathname).slice(0, 255);
    } catch (ignore) {
      return String(source).slice(0, 255);
    }
  }

  function report(kind, message, source, line, column, error) {
    var browser = browserName();
    var category = sourceCategory(source);
    if (!source && /-in-app$/.test(browser)) category = 'in-app-browser-injected-or-cross-origin';

    var payload = {
      kind: kind,
      message: String(message || 'Script error.').slice(0, 180),
      page: window.location.pathname,
      browser: browser,
      source: normaliseSource(source),
      sourceCategory: category,
      line: Number(line) || 0,
      column: Number(column) || 0,
      stack: error && error.stack ? String(error.stack).slice(0, 1500) : ''
    };

    window.__oneisallJsErrors = window.__oneisallJsErrors || [];
    window.__oneisallJsErrors.push(payload);
    if (window.__oneisallJsErrors.length > 50) window.__oneisallJsErrors.shift();
    window.dispatchEvent(new CustomEvent('oneisall:javascript-error', { detail: payload }));

    if (typeof window.clarity === 'function') {
      window.clarity('set', 'js_error_page', payload.page);
      window.clarity('set', 'js_error_browser', payload.browser);
      window.clarity('set', 'js_error_source', payload.source);
      window.clarity('set', 'js_error_category', payload.sourceCategory);
      window.clarity('event', 'javascript-error');
    }
  }

  window.addEventListener('error', function (event) {
    var resourceSource = event.target && event.target.tagName === 'SCRIPT' ? event.target.src : '';
    report(resourceSource ? 'resource-error' : 'error', event.message, resourceSource || event.filename, event.lineno, event.colno, event.error);
  }, true);

  window.addEventListener('unhandledrejection', function (event) {
    var reason = event.reason || {};
    report('unhandledrejection', reason.message || String(reason), reason.fileName || '', reason.lineNumber, reason.columnNumber, reason);
  });
})(window);
